<template>
    <v-row>
      <v-col rows="12" sm="3">
        <v-autocomplete
          class="mt-3"
          :label="$t('keywords.id')"
          v-model="monitoringIDFilter"
          dense
          outlined
          :items="monitoringIDList"
        />
      </v-col>
      <v-col rows="12" sm="3">
        <v-select
          v-model="numberLinesFilter"
          :items="numberLinesOptions"
          :label="$t('monitoring.lines_number')"
          class="mt-3"
          outlined
          dense
        />
      </v-col>
      <v-col rows="12" sm="3">
        <v-select
          item-value="value"
          :items="statusList"
          item-text="text"
          class="mt-3"
          :label="$t('monitoring.status')"
          v-model="statusFilter"
          dense
          outlined
        />
      </v-col>
      <v-col rows="12" sm="3">
        <DateRange />
      </v-col>
    </v-row>
</template>
<script>
import DateRange from './DateRange.vue'

export default {
  name: 'Filters',

  components: { DateRange },

  props: {
    items: Array,
    numberLinesOptions: Array
  },

  computed: {
    allItemsOption () {
      return {
        text: this.$t('keywords.all'),
        value: ''
      }
    },
    monitoringIDFilter: {
      get () { return this.$route.query.monitoringIDFilter ?? '' },
      set (monitoringIDFilter) { this.setQueryParam({ monitoringIDFilter }) }
    },
    numberLinesFilter: {
      get () {
        const { numberLinesFilter } = this.$route.query
        return this.numberLinesOptions.includes(numberLinesFilter) ? numberLinesFilter : '10'
      },
      set (numberLinesFilter) { this.setQueryParam({ numberLinesFilter }) }
    },
    statusFilter: {
      get () { return this.$route.query.statusFilter ?? '' },
      set (statusFilter) { this.setQueryParam({ statusFilter }) }
    },
    monitoringIDList () {
      const justMonitoringIDs = this.items.map(obj => obj.monitoringID)
      return [this.allItemsOption, ...justMonitoringIDs]
    },
    statusList () {
      const justStatus = this.items.map(this.getStatusItem)
      return [this.allItemsOption, ...justStatus]
    }
  },

  methods: {
    getStatusItem ({ status }) {
      return {
        value: status,
        text: this.$t('monitoring.status_values.' + status)
      }
    },
    setQueryParam (obj) {
      const query = { ...this.$route.query, ...obj }
      this.$router.replace({ query })
    }
  }

}
</script>
